interface ErrorBannersProps {
  errors: string[];
  onDismiss: (index: number) => void;
}

/**
 * Renders a fixed, top-centered list of dismissible error banners.
 * Matches the existing style used on CreateTaskPage.
 */
export default function ErrorBanners({ errors, onDismiss }: ErrorBannersProps) {
  if (errors.length === 0) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: '60px',
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      {errors.map((err, idx) => (
        <div
          key={idx}
          className="error-banner"
          style={{
            background: '#fdd',
            padding: '8px',
            marginBottom: '8px',
            width: '100%',
            maxWidth: '1024px',
          }}
        >
          {err}
          <button
            type="button"
            onClick={() => onDismiss(idx)}
            className="error-banner__close"
            aria-label="Dismiss error"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
